import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { cancelAndRefundOrDiscountOrder } from '../../../../../actions/tools/DecisionTreeCopyTextActions';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import { getSelectedOrderId } from 'selectors/tools';
import { getAdditionalOrderDetails } from 'extractFromState';

const DTCancelAndRefundOrDiscountOrderItemsThenSendMacroNode = () => {
  const dispatch = useDispatch();
  const selectedOrderId = useSelector(getSelectedOrderId);
  const additionalOrderDetails = useSelector(getAdditionalOrderDetails);

  const getAdditionalOrderParameters = () => {
    const additionalOrderParameters = {};
    const numberOfCycles = additionalOrderDetails?.[selectedOrderId]?.numberOfCycles;
    if (numberOfCycles) {
      additionalOrderParameters.numberOfCycles = numberOfCycles;
    }

    return additionalOrderParameters;
  };

  const handleNextButtonClick = async () =>
    await dispatch(cancelAndRefundOrDiscountOrder(getAdditionalOrderParameters()));

  return (
    <DTCopyTextSendMacroView
      buttonText={'EXECUTE ACTION'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={false}
      popupConfirmationText={'You are about to cancel and refund or discount items in this order'}
    />
  );
};

export default withConfirmation(DTCancelAndRefundOrDiscountOrderItemsThenSendMacroNode);
